export type TeamCategoryType = "All" | "Active" | "Archived";
export const TeamCategoryTypes = {
    All: "All" as TeamCategoryType,
    Active: "Active" as TeamCategoryType,
    Archived: "Archived" as TeamCategoryType
};